import api from './api';
import { getErrorMessage } from '../utils/errorHandler';

const employeeService = {
  // Get all employees with filters and pagination
  getEmployees: async (params = {}) => {
    return api.get('/hr/employees', { params });
  },

  // Get employee by ID with comprehensive data
  getEmployeeById: async (id) => {
    return api.get(`/hr/employees/${id}`);
  },

  // Create new employee
  createEmployee: async (employeeData) => {
    return api.post('/hr/employees', employeeData);
  },

  // Update employee
  updateEmployee: async (id, employeeData) => {
    return api.put(`/hr/employees/${id}`, employeeData);
  },

  // Get employee dashboard data
  getEmployeeDashboard: async (id) => {
    return api.get(`/hr/employees/${id}/dashboard`);
  },

  // Employment History
  getEmploymentHistory: async (id) => {
    return api.get(`/hr/employees/${id}/history`);
  },

  // Performance Reviews
  getPerformanceReviews: async (id, params = {}) => {
    return api.get(`/hr/employees/${id}/reviews`, { params });
  },

  // Document Management
  getEmployeeDocuments: async (id, params = {}) => {
    return api.get(`/hr/employees/${id}/documents`, { params });
  },

  uploadDocument: async (id, formData) => {
    return api.post(`/hr/employees/${id}/documents`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // Onboarding
  getOnboardingTasks: async (id, params = {}) => {
    return api.get(`/hr/employees/${id}/onboarding`, { params });
  },

  updateOnboardingTask: async (taskId, taskData) => {
    return api.put(`/hr/employees/onboarding/${taskId}`, taskData);
  },

  // Departments
  getDepartments: async () => {
    try {
      return api.get('/hr/departments');
    } catch (error) {
      console.error('Service error:', error);
      const errorMessage = getErrorMessage(error);
      throw new Error(errorMessage);
    }
  },

  // Roles
  getRoles: async () => {
    try {
      return api.get('/admin/roles');
    } catch (error) {
      console.error('Service error:', error);
      const errorMessage = getErrorMessage(error);
      throw new Error(errorMessage);
    }
  },

  // HR Management Actions
  resetEmployeePassword: async (id, password) => {
    try {
      return api.post(`/employees/${id}/reset-password`, { password });
    } catch (error) {
      console.error('Service error:', error);
      const errorMessage = getErrorMessage(error);
      throw new Error(errorMessage);
    }
  },

  toggleEmployeeSuspension: async (id, suspend, reason = '') => {
    try {
      return api.post(`/employees/${id}/toggle-suspension`, {
        suspend,
        reason
      });
    } catch (error) {
      console.error('Service error:', error);
      const errorMessage = getErrorMessage(error);
      throw new Error(errorMessage);
    }
  }
};

export default employeeService;